<template>
  <div class="c-sleeve-selector l-flex">
    <div class="c-sleeve-selector__container l-flex l-flex--column">
      <h1
        ref="headingToFocus"
        class="c-sleeve-selector__title t-heading-5 u-margin-bottom-small"
        tabindex="0"
      >
        {{ step.personalizationTitle }}
      </h1>
      <!-- eslint-disable vue/no-v-html -->
      <p
        class="c-sleeve-selector__description t-paragraph-large u-margin-bottom-small"
        v-html="step.personalizationDescription"
      />
      <!-- eslint-enable vue/no-v-html -->
      <div
        class="u-margin-bottom-medium"
      >
        <checkbox
          :value="sleeveAdded"
          @input="toggleSleeve"
        >
          <!--          Add a sleeve for ${{ engravingFee.price }}-->
          Add a sleeve for
          <product-price
            :price="sleevePrice | currency"
            :compare-at-price="sleeveCompareAtPrice | currency"
          />
        </checkbox>
      </div>

      <btn
        :class-modifiers="step.button.fields.type"
        class="c-band-color-selector__next-btn u-margin-bottom-x-small"
        @click="incrementStep"
      >
        {{ step.button.fields.text }} {{ nextStep.fields.personalizationTitle }}
      </btn>

      <p class="t-paragraph-small">
        {{ step.personalizationHelpText }}
      </p>

      <btn
        type="link"
        url="#"
        @click="decrementStep"
      >
        BACK
      </btn>
    </div>
  </div>
</template>

<script>

import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import Btn from "@/components/button/Btn";
import Checkbox from "@/components/checkbox/Checkbox";
import ProductPrice from "@/components/productPrice/ProductPrice";
import isNumber from 'lodash/isNumber'

export default {
  name: "SleeveSelector",
  components: {
    Btn,
    Checkbox,
    ProductPrice
  },
  props: {
    step: {
      type: Object,
      default: null
    },
    defaultWithSleeve: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('braceletBuilder', [
      'sleeves',
      'selections',
      'currentStep'
    ]),
    ...mapGetters('braceletBuilder',[
      'loading',
      'nextStep',
      'engravingFee',
      'claspColor',
      'claspFinish',
      'compatibleSleeve',
      'sleeveFee'
    ]),
    sleeveAdded() {
      return !!this.selections.sleeve;
    },
    sleevePrice() {
      let result = 0.0
      const price = isNumber(this.sleeveFee.price)
        ? this.sleeveFee.price
        : parseFloat(this.sleeveFee.price)
      return result += isNaN(price) ? 0.0 : price
    },
    sleeveCompareAtPrice() {
      let result = 0.0
      const price = isNumber(this.sleeveFee.compareAtPrice)
        ? this.sleeveFee.compareAtPrice
        : parseFloat(this.sleeveFee.compareAtPrice)
      return result += isNaN(price) ? 0.0 : price
    }
  },
  /**
   * if builder should default with a sleeve added, toggle on mount
   */
  mounted() {
    //Accessibility focus
    const headingToFocus = this.$refs.headingToFocus;
    if (headingToFocus) {
      this.$refs.headingToFocus.focus();
    }

    if (this.defaultWithSleeve && !this.selections.sleeve) {
      return this.toggleSleeve()
    }
  },
  methods: {
    ...mapMutations('braceletBuilder', [
      'update'
    ]),
    ...mapActions('braceletBuilder', [
      'incrementStep',
      'decrementStep',
      'toggleSleeve'
    ]),
  }
}
</script>

<style scoped>

</style>
